const fetchLocalLocalizationFile = async () => {
  return await import(`../../storage/web/public/lang/en.json`);
};

const loadLocalLocalizationConfig = async () => {
  return await import(`../../storage/web/public/lang/config.json`);
};

export { loadLocalLocalizationConfig, fetchLocalLocalizationFile };
